import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';
import { Paper, Grid } from '@material-ui/core';

const styles = theme => ({
    layoutRoot: {},
});

class GhostList extends Component {
    render()
    {
        // const {classes} = this.props;

        return (
            <Paper className="p-16" style={{margin:5}}>
                <Grid container spacing={8}>
                    <Grid item xs={12} sm={1} className="noMobile">
                        <div className="blink" style={{height: '100%', width: '100%', marginBottom: 7, background: '#cecece'}}>
                            &nbsp;
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={5}>
                        <div className="blink" style={{height: 16, width: '100%', marginBottom: 7, background: '#cecece'}}>
                            &nbsp;
                        </div>
                        <div className="blink" style={{height: 16, width: '50%', marginBottom: 7, background: '#cecece'}}>
                            &nbsp;
                        </div>
                        <div className="blink" style={{height: 16, width: '60%', marginBottom: 7, background: '#cecece'}}>
                            &nbsp;
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={5} className="noMobile">
                        <div className="blink" style={{height: 16, width: '100%', marginBottom: 7, background: '#cecece'}}>
                            &nbsp;
                        </div>
                        <div className="blink" style={{height: 16, width: '50%', marginBottom: 7, background: '#cecece'}}>
                            &nbsp;
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={1} className="noMobile">
                        <div className="blink" style={{float: 'right', height: 30, width: 30, marginBottom: 7, background: '#cecece'}}>
                            &nbsp;
                        </div>
                    </Grid>
                </Grid>
            </Paper>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getSekolah: Actions.getSekolah,
        setKunciKonfirmasiInstrumen: Actions.setKunciKonfirmasiInstrumen,
        getKonfirmasiSelesai: Actions.getKonfirmasiSelesai,
        getPeringkatPengisian: Actions.getPeringkatPengisian,
        setJudul: Actions.setJudul
    }, dispatch);
}

function mapStateToProps({ Sekolah, Instrumen }) {

    return {
        sekolah: Sekolah.sekolah,
        konfirmasi_instrumen_id: Instrumen.konfirmasi_instrumen_id,
        konfirmasi_instrumen: Instrumen.konfirmasi_instrumen,
        peringkat_pengisian: Instrumen.peringkat_pengisian
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(GhostList)));


// WEBPACK FOOTER //
// ./src/main/content/components/GhostList.js